module.exports = __webpack_public_path__ + "static/UIButtons-542ff4698d281512a859e63317947a34.jpg";